import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthenticationService, CredentialsService } from '@app/core';
import { environment } from '@env/environment';
import moment from 'moment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/authentication/authentication.service";
import * as i3 from "../core/authentication/credentials.service";
export class VouchersService {
    constructor(http, authService, credentialsService) {
        this.http = http;
        this.authService = authService;
        this.credentialsService = credentialsService;
    }
    getSettings() {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .get(environment.serverUrl + `voucher/settings/` + this.authService.activeClientId, {
            headers: headers
        })
            .pipe(map((settings) => {
            return settings;
        }));
    }
    getClientPool(startDate, endDate) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .get(environment.serverUrl +
            `voucher/pool/` +
            this.authService.activeClientId +
            '/' +
            moment(startDate).format('YYYY-MM-DD') +
            '/' +
            moment(endDate).format('YYYY-MM-DD'), {
            headers: headers
        })
            .pipe(map((settings) => {
            return settings;
        }));
    }
    getPoolLiability(startDate, endDate) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .get(environment.serverUrl +
            `voucher/pool-liability/` +
            this.authService.activeClientId +
            '/' +
            moment(startDate).format('YYYY-MM-DD') +
            '/' +
            moment(endDate).format('YYYY-MM-DD'), {
            headers: headers
        })
            .pipe(map((liability) => {
            return liability;
        }));
    }
    getCommunityPoolLiability(startDate, endDate) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .get(environment.serverUrl +
            `voucher/pool-community-liability/` +
            this.authService.activeClientId +
            '/' +
            moment(startDate).format('YYYY-MM-DD') +
            '/' +
            moment(endDate).format('YYYY-MM-DD'), {
            headers: headers
        })
            .pipe(map((liability) => {
            return liability;
        }));
    }
    getTransactions(clientId, startDate, endDate, page = 0, status = '', voucherCode = '') {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + `voucher/transactions/` + (clientId ? clientId : this.authService.activeClientId), {
            startDate,
            endDate,
            page,
            status: status,
            voucherCode
        }, {
            headers: headers
        })
            .pipe(map((transactions) => {
            return transactions;
        }));
    }
    getTransactionsDataTil(clientId, startDate, endDate) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + `voucher/transactionsData/` + (clientId ? clientId : this.authService.activeClientId), {
            startDate,
            endDate
        }, {
            headers: headers
        })
            .pipe(map((transactions) => {
            return transactions;
        }));
    }
    getVouchers(startDate = '', endDate = '', page = 0) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + `voucher/vouchers/` + this.authService.activeClientId, {
            startDate,
            endDate,
            page
        }, {
            headers: headers
        })
            .pipe(map((transactions) => {
            return transactions;
        }));
    }
    getBalanceTransactions(startDate, endDate, page = 0) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + `voucher/balance-transactions/` + this.authService.activeClientId, {
            startDate,
            endDate,
            page
        }, {
            headers: headers
        })
            .pipe(map((transactions) => {
            return transactions;
        }));
    }
    saveVoucherSettings(data) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + `voucher/voucher-settings/save/` + this.authService.activeClientId, { data }, { headers: headers })
            .pipe(map((resp) => {
            return resp;
        }));
    }
    getExcelEvaluationList(startDate, endDate) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cred.token
        });
        window.open(environment.serverUrl +
            `voucher/evaluation-xls/` +
            this.authService.activeClientId +
            '/' +
            moment(startDate).format('YYYY-MM-DD') +
            '/' +
            moment(endDate).format('YYYY-MM-DD'), '_blank');
        return true;
        /*
        return this.http
          .get<any>(
            environment.serverUrl +
              `voucher/evaluation-xls/` +
              this.authService.activeClientId +
              '/' +
              startDate +
              '/' +
              endDate,
            {
              headers: headers
            }
          )
          .pipe(
            map((result: any) => {
              return result;
            })
          );
          */
    }
    getPayouts(type = '') {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .get(environment.serverUrl + `voucher/payouts/` + this.authService.activeClientId + type, {
            headers: headers
        })
            .pipe(map((payouts) => {
            return payouts;
        }));
    }
    getVoucherBalance(payoutId = 0) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .get(environment.serverUrl + `voucher/balance/${this.authService.activeClientId}/${payoutId}`, {
            headers: headers
        })
            .pipe(map((payouts) => {
            return payouts;
        }));
    }
    requestPayout(path = 'voucher') {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + path + `/payouts/`, { clientId: this.authService.activeClientId }, {
            headers: headers
        })
            .pipe(map((resp) => {
            return resp;
        }));
    }
    getVoucherTransactionsPdf(data = { orders: [] }) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + cred.token,
            Accept: 'application/pdf'
        });
        return this.http
            .post(environment.serverUrl + `voucher/createVoucherTransactionsPdf/`, data, { headers, responseType: 'blob' })
            .pipe(map(response => {
            if (response.type !== 'application/pdf') {
                throw new Error('Received non-PDF response');
            }
            return new Blob([response], { type: 'application/pdf' });
        }));
    }
    getVoucherOrders(from = null, to = null, filterBy = '') {
        if (from === null) {
            from = moment()
                .subtract(7, 'days')
                .format();
        }
        if (to === null) {
            to = moment().format();
        }
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + `voucher/voucher-orders/` + this.authService.activeClientId, {
            startDate: from,
            endDate: to,
            filterBy: filterBy
        }, {
            headers: headers
        })
            .pipe(map((stats) => {
            return stats;
        }));
    }
    setShippingDate(orderId, voucherCodes) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + `voucher/set-shipping-date`, {
            orderId: orderId,
            voucherCodes: voucherCodes
        }, {
            headers: headers
        })
            .pipe(map((order) => {
            return order;
        }));
    }
    downloadReceipt(receipt) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + cred.token
        });
        this.http
            .get(environment.serverUrl + `voucher/downloadReceipt/${receipt.betriebId}/${receipt.id}`, {
            headers,
            responseType: 'blob'
        }) //set response Type properly (it is not part of headers)
            .toPromise()
            .then(blob => {
            saveAs(blob, 'receipt.pdf');
        })
            .catch(err => console.error('download error = ', err));
    }
    sendReceipt(receipt) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + cred.token
        });
        this.http
            .get(environment.serverUrl + `voucher/sendReceipt/${receipt.betriebId}/${receipt.id}`, {
            headers: headers
        })
            .toPromise()
            .then(data => {
            alert('Quittung wurde erfolgreich an ' + receipt.email + ' versendet!');
            console.log('send email to ', receipt);
        })
            .catch(err => console.error('send email error = ', err));
    }
    sendVoucherPdf(voucherPdf) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + `voucher/sendVoucherPdf`, {
            clientId: voucherPdf.betriebId,
            id: voucherPdf.id,
            email: voucherPdf.email
        }, {
            headers: headers
        })
            .pipe(map((response) => {
            return response;
        }));
    }
    getVoucherTransactions(clientId, voucherCode) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + `voucher/all-vouchers`, {
            clientId,
            voucherCode,
            limit: 100
        }, {
            headers: headers
        })
            .pipe(map((transactions) => {
            return transactions;
        }));
    }
    getVoucherStatistics(from = null, to = null) {
        if (from === null) {
            from = moment()
                .subtract(7, 'days')
                .format();
        }
        if (to === null) {
            to = moment().format();
        }
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + `voucher/voucher-statistics/` + this.authService.activeClientId, {
            startDate: from,
            endDate: to
        }, {
            headers: headers
        })
            .pipe(map((stats) => {
            return stats;
        }));
    }
    getVoucherValidity() {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .get(environment.serverUrl + `voucher/vouchers-validity/` + this.authService.activeClientId, {
            headers: headers
        })
            .pipe(map((response) => {
            return response;
        }));
    }
    getAllPoolClientsData(poolClientId) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + `voucher/pool-client-data`, {
            clientIds: poolClientId ? poolClientId : this.authService.activeClientId
        }, {
            headers: headers
        })
            .pipe(map((transactions) => {
            return transactions;
        }));
    }
    getVoucherResidualValues(startDate, endDate) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cred.token
        });
        window.open(environment.serverUrl +
            `voucher/pool-stats/` +
            this.authService.activeClientId +
            '/' +
            moment(startDate).format('YYYY-MM-DD') +
            '/' +
            moment(endDate).format('YYYY-MM-DD'), '_blank');
        return true;
    }
    uploadHeaderBackgroundVouchers(uploadData) {
        uploadData.append('clientId', this.authService.activeClientId);
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + `voucher/upload-header-background-vouchers`, uploadData, {
            headers: headers
        })
            .pipe(map((response) => {
            return response;
        }));
    }
    /* For Voucher APIs*/
    getVoucherDetails(data) {
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + data.token
        });
        return this.http
            .post(environment.serverUrl + `rest-api/1.0/voucher/get-details/`, data, {
            headers: headers
        })
            .pipe(map((res) => {
            return res;
        }));
    }
    redeemVoucher(data) {
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + data.token
        });
        return this.http
            .post(environment.serverUrl + `rest-api/1.0/voucher/redeem-voucher/`, data, {
            headers: headers
        })
            .pipe(map((res) => {
            return res;
        }));
    }
    rechargeVoucher(data) {
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + data.token
        });
        return this.http
            .post(environment.serverUrl + `rest-api/1.0/voucher/recharge-voucher/`, data, {
            headers: headers
        })
            .pipe(map((res) => {
            return res;
        }));
    }
    cancelVoucherOrder(voucher) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + `voucher/cancel`, {
            betriebId: voucher.betriebId,
            id: voucher.id,
            total: voucher.total
        }, {
            headers: headers
        })
            .pipe(map((response) => {
            return response;
        }));
    }
    getBalancedCanceledVouchers(clientId, startDate, endDate) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl +
            `voucher/balanced-canceled-vouchers/` +
            (clientId ? clientId : this.authService.activeClientId), {
            startDate,
            endDate
        }, {
            headers: headers
        })
            .pipe(map((transactions) => {
            return transactions;
        }));
    }
    getVoucherStatDoughnut(from = null, to = null) {
        if (from === null) {
            from = moment()
                .subtract(7, 'days')
                .format();
        }
        if (to === null) {
            to = moment().format();
        }
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + `voucher/voucher-statistics-chart/` + this.authService.activeClientId, {
            startDate: from,
            endDate: to
        }, {
            headers: headers
        })
            .pipe(map((stats) => {
            return stats;
        }));
    }
    cancelVoucherTransaction(transactionId, cancelReasonText) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.serverUrl + `voucher/cancel-voucher-transaction/` + transactionId, {
            memberId: cred.id,
            cancelReasonText
        }, {
            headers: headers
        })
            .pipe(map((result) => {
            return result;
        }));
    }
    getVoucherDetail(code) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        return this.http
            .get(environment.serverUrl + `voucher/voucher-detail/${this.authService.activeClientId}/${code}`, {
            headers: headers
        })
            .pipe(map((areas) => {
            return areas;
        }));
    }
    prepareVoucherPdf(voucherId) {
        const cred = this.credentialsService.credentials;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + cred.token
        });
        return this.http
            .post(environment.mainServerUrl + `voucher/prepare-voucher-pdf`, {
            voucherId: voucherId
        }, {
            headers: headers,
            reportProgress: true
        })
            .pipe(map((response) => {
            return response;
        }));
    }
}
VouchersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VouchersService_Factory() { return new VouchersService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthenticationService), i0.ɵɵinject(i3.CredentialsService)); }, token: VouchersService, providedIn: "root" });
